import { Deserializable } from '../deserializable';

export class TransactionDeals implements Deserializable {
  public id: number;
  public transactionId: number;
  public dealRate: number | null;
  public retryCount: number;
  public lastMessage: string;
  public created: string;
  public lastUpdated: string;
  public mercantileConfirmationTransactionId: string;
  public bookNowReceived: string;
  public overriddenDealType: string;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
